import request from '@/utils/request';
import { endpoints } from '@/constants/urls';

const announcements = () => (
  request({
    url: endpoints.ANNOUNCEMENTS,
    method: 'GET',
  })
);

const AnnouncementsService = {
  announcements,
};

export default AnnouncementsService;
